
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * BackupModuleSyncStatus enum
 */
class BackupModuleSyncStatus {
  /**
   * Initialize enum with a given value
   * @param {BackupModuleSyncStatus|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof BackupModuleSyncStatus) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!BackupModuleSyncStatus}
   * @param {!BackupModuleSyncStatus} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof BackupModuleSyncStatus)) {
      throw new TypeError('Instance of BackupModuleSyncStatus is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!BackupModuleSyncStatus}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!BackupModuleSyncStatus}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === BackupModuleSyncStatus.DISABLED.value) {
      return 'DISABLED'
    }
    if (this.value === BackupModuleSyncStatus.ERROR.value) {
      return 'ERROR'
    }
    if (this.value === BackupModuleSyncStatus.IN_PROGRESS.value) {
      return 'IN_PROGRESS'
    }
    if (this.value === BackupModuleSyncStatus.UP_TO_DATE.value) {
      return 'UP_TO_DATE'
    }
    if (this.value === BackupModuleSyncStatus.WARNING.value) {
      return 'WARNING'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!BackupModuleSyncStatus}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!BackupModuleSyncStatus}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!BackupModuleSyncStatus} Created enum
   */
  static fromObject (other) {
    return new BackupModuleSyncStatus(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
BackupModuleSyncStatus.DISABLED = new BackupModuleSyncStatus(0 + 0)
// noinspection PointlessArithmeticExpressionJS
BackupModuleSyncStatus.ERROR = new BackupModuleSyncStatus(0 + 1)
// noinspection PointlessArithmeticExpressionJS
BackupModuleSyncStatus.IN_PROGRESS = new BackupModuleSyncStatus(0 + 2)
// noinspection PointlessArithmeticExpressionJS
BackupModuleSyncStatus.UP_TO_DATE = new BackupModuleSyncStatus(0 + 3)
// noinspection PointlessArithmeticExpressionJS
BackupModuleSyncStatus.WARNING = new BackupModuleSyncStatus(0 + 4)

export { BackupModuleSyncStatus };

/**
 * Fast Binary Encoding BackupModuleSyncStatus field model
 */
class FieldModelBackupModuleSyncStatus extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelBackupModuleSyncStatus}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the value
   * @this {!FieldModelBackupModuleSyncStatus}
   * @param {BackupModuleSyncStatus=} defaults Default value, defaults is new BackupModuleSyncStatus()
   * @returns {!BackupModuleSyncStatus} Result value
   */
  get (defaults = new BackupModuleSyncStatus()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new BackupModuleSyncStatus(this.readInt32(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelBackupModuleSyncStatus}
   * @param {!BackupModuleSyncStatus} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeInt32(this.fbeOffset, value.value)
  }
}

export { FieldModelBackupModuleSyncStatus };
